import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { parse } from 'yaml'

import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'
import { useOrg } from '@/hooks'
import useValidateEndpoint from '@/hooks/useValidate'
import { ConfigDataScreen } from '@/screens/ComponentLibrary/components'
import { useGetCustomComponent } from '@/screens/ComponentLibrary/hooks'
import { camelize, parseComponentTypes } from '@/utils'
import { ComponentType } from '@/utils/api'

import { RecipeCustomComponent } from './RecipeEditor'

export const parseRecipeData = (
  orgSlug?: string | null,
  param?: { settings: RecipeCustomComponent; name: string } | string | null
) => {
  if (!param || !orgSlug) return {}
  const data = parseComponentTypes(param, ComponentType.recipe)
  const steps = parse(data?.settings.recipe || '')?.steps
  return {
    data: {
      name: data?.name.split('/').map(camelize).join('/'),
      recipeVersion: '1.0',
      schemaVersion: '2.0',
      ...(steps && { steps }),
    },
    organization: orgSlug,
    schemaName: 'RecipeConfig',
    schemaVersion: '1.0.0',
    version: '1.0.0',
  }
}

export const useParseRecipeData = (
  orgSlug?: string | null,
  param?: { settings: RecipeCustomComponent; name: string } | string | null
) => {
  return useMemo(() => {
    return parseRecipeData(orgSlug, param)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(param), orgSlug])
}

export const ConfigData = () => {
  const { orgID } = useParams()
  const { componentID } = useComponentProvider()
  const org = useOrg(orgID)
  const current = useGetCustomComponent<RecipeCustomComponent>(componentID)

  const config = useParseRecipeData(org.data?.slug, current.data)
  const valid = useValidateEndpoint(config, componentID)

  return (
    <ConfigDataScreen
      config={config}
      current={current}
      org={org}
      rootName="Recipe"
      valid={valid}
    />
  )
}
